import axios from 'axios'
import keycloak from '@/keycloak'
import { config } from '@/config'

// Rafraîchi si le jeton expire dans moins de 30 s : couvre la sortie de veille, quand le timer de main.ts n'a pas tourné
const VALIDITE_MIN_JETON_S = 30

const axiosInstance = axios.create({
  baseURL: `${config.apiUrl}/v3`,
})

axiosInstance.interceptors.request.use(async (config) => {
  // Échec réseau : la requête part avec le jeton courant et échouera d'elle-même. Session morte : keycloak-js
  // renvoie déjà vers la connexion (login-required).
  await keycloak.updateToken(VALIDITE_MIN_JETON_S).catch(() => {})
  if (keycloak.token) {
    config.headers.Authorization = `Bearer ${keycloak.token}`
  }
  return config
})

export default axiosInstance
